import React from "react";
import Layout1 from "./Layout/Layout1";

function Phase2() {
  return (
    <React.Fragment>
      <div>
        <Layout1 />
      </div>
    </React.Fragment>
  );
}

export default Phase2;
